export default {"src":"/_next/static/media/blk.952b6026.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};